import api from "../config/api";
import { Employee } from "../types/Employee";
import {
  ForgotPasswordRequest,
  ResetPasswordData,
  VerifyOtpData,
} from "../types/ForgotPassword";

const API_URL = "/forgotPassword";

// give request
export const requestOtp = (data: ForgotPasswordRequest) =>
  api.post(`${API_URL}/`, data);

// to check otp is correct or not
export const verifyOtp = (employeeId: string, data: VerifyOtpData) =>
  api.post(`${API_URL}/?action=verifyOtp&employeeId=${employeeId}`, data);

// Reset Password
export const resetPassword = (employeeId: string, data: ResetPasswordData) =>
  api.post(`${API_URL}/?action=updatePassword&employeeId=${employeeId}`, data);
